import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_85e30de2 from 'nuxt_plugin_plugin_85e30de2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_0eb5cd69 from 'nuxt_plugin_sentryserver_0eb5cd69' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_ae07483e from 'nuxt_plugin_sentryclient_ae07483e' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_c81caa92 from 'nuxt_plugin_plugin_c81caa92' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_pluginutils_5bd22b94 from 'nuxt_plugin_pluginutils_5bd22b94' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_5e05c201 from 'nuxt_plugin_pluginrouting_5e05c201' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_70b5510e from 'nuxt_plugin_pluginmain_70b5510e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_templatesplugin2ed64db8_5a8a254a from 'nuxt_plugin_templatesplugin2ed64db8_5a8a254a' // Source: ./templates.plugin.2ed64db8.js (mode: 'client')
import nuxt_plugin_templatesplugin0d399cf2_1a018985 from 'nuxt_plugin_templatesplugin0d399cf2_1a018985' // Source: ./templates.plugin.0d399cf2.js (mode: 'all')
import nuxt_plugin_nuxtmq_42d96e6d from 'nuxt_plugin_nuxtmq_42d96e6d' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_axios_35ca82a5 from 'nuxt_plugin_axios_35ca82a5' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_distplugin52381732_641c8b46 from 'nuxt_plugin_distplugin52381732_641c8b46' // Source: ./dist.plugin.52381732.mjs (mode: 'all')
import nuxt_plugin_buefy_354d55e2 from 'nuxt_plugin_buefy_354d55e2' // Source: ../../../plugins/buefy (mode: 'all')
import nuxt_plugin_webrtcadapter_036852f4 from 'nuxt_plugin_webrtcadapter_036852f4' // Source: ../../../src/shared/lib/webrtc/webrtc-adapter.plugin (mode: 'client')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../../../plugins/vuelidate (mode: 'client')
import nuxt_plugin_sentry_7ebb9398 from 'nuxt_plugin_sentry_7ebb9398' // Source: ../../../src/shared/lib/sentry/sentry.plugin (mode: 'client')
import nuxt_plugin_api_a6078344 from 'nuxt_plugin_api_a6078344' // Source: ../../../src/shared/lib/api/api.plugin (mode: 'all')
import nuxt_plugin_cookiesAccess_4e96f92c from 'nuxt_plugin_cookiesAccess_4e96f92c' // Source: ../../../src/shared/lib/cookiesAccess/cookiesAccess.plugin (mode: 'client')
import nuxt_plugin_amplitude_c13dac68 from 'nuxt_plugin_amplitude_c13dac68' // Source: ../../../src/shared/lib/amplitude/amplitude.plugin (mode: 'client')
import nuxt_plugin_gtag_0ac39a98 from 'nuxt_plugin_gtag_0ac39a98' // Source: ../../../src/shared/lib/gtag/gtag.plugin (mode: 'client')
import nuxt_plugin_googleAnalytics_218e57a4 from 'nuxt_plugin_googleAnalytics_218e57a4' // Source: ../../../src/shared/lib/gtag/googleAnalytics.plugin (mode: 'client')
import nuxt_plugin_facebook_7eccbd58 from 'nuxt_plugin_facebook_7eccbd58' // Source: ../../../src/shared/lib/facebook/facebook.plugin (mode: 'client')
import nuxt_plugin_hotjar_2a882914 from 'nuxt_plugin_hotjar_2a882914' // Source: ../../../src/shared/lib/hotjar/hotjar.plugin (mode: 'client')
import nuxt_plugin_analytics_1e2158c6 from 'nuxt_plugin_analytics_1e2158c6' // Source: ../../../src/shared/lib/analytics/analytics.plugin (mode: 'client')
import nuxt_plugin_modal_0afd60a8 from 'nuxt_plugin_modal_0afd60a8' // Source: ../../../plugins/modal/modal.plugin (mode: 'client')
import nuxt_plugin_modal_442ddd06 from 'nuxt_plugin_modal_442ddd06' // Source: ../../../src/shared/plugins/modal/modal.plugin (mode: 'client')
import nuxt_plugin_toaster_ad413bd6 from 'nuxt_plugin_toaster_ad413bd6' // Source: ../../../src/shared/plugins/toaster/model/toaster.plugin (mode: 'client')
import nuxt_plugin_meta_54e2c789 from 'nuxt_plugin_meta_54e2c789' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"translate":"no"},"title":"#1 Video Chat to Meet New Friends","meta":[{"charset":"utf-8"},{"name":"google","content":"notranslate"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"},{"hid":"description","name":"description","content":"Discover Peachfy — live video chat app. Thousands of real and verified people from around the world are online and waiting for you. Start video chat now!"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"peachfy.com"},{"property":"og:title","content":"Peachfy - #1 Video Chat to Meet New Friends"},{"property":"og:description","content":"Thousands of real and verified people from around the world are online and waiting for you. Start video chat now!"},{"property":"og:url","content":"https:\u002F\u002Fpeachfy.com"},{"property":"og:image","content":"https:\u002F\u002Fpeachfy.com\u002Fog-image.jpg"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:wght@400;500;600;700&display=swap"}],"script":[],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_85e30de2 === 'function') {
    await nuxt_plugin_plugin_85e30de2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_0eb5cd69 === 'function') {
    await nuxt_plugin_sentryserver_0eb5cd69(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_ae07483e === 'function') {
    await nuxt_plugin_sentryclient_ae07483e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_c81caa92 === 'function') {
    await nuxt_plugin_plugin_c81caa92(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_5bd22b94 === 'function') {
    await nuxt_plugin_pluginutils_5bd22b94(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_5e05c201 === 'function') {
    await nuxt_plugin_pluginrouting_5e05c201(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_70b5510e === 'function') {
    await nuxt_plugin_pluginmain_70b5510e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin2ed64db8_5a8a254a === 'function') {
    await nuxt_plugin_templatesplugin2ed64db8_5a8a254a(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin0d399cf2_1a018985 === 'function') {
    await nuxt_plugin_templatesplugin0d399cf2_1a018985(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_42d96e6d === 'function') {
    await nuxt_plugin_nuxtmq_42d96e6d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_35ca82a5 === 'function') {
    await nuxt_plugin_axios_35ca82a5(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin52381732_641c8b46 === 'function') {
    await nuxt_plugin_distplugin52381732_641c8b46(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_354d55e2 === 'function') {
    await nuxt_plugin_buefy_354d55e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webrtcadapter_036852f4 === 'function') {
    await nuxt_plugin_webrtcadapter_036852f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_7ebb9398 === 'function') {
    await nuxt_plugin_sentry_7ebb9398(app.context, inject)
  }

  if (typeof nuxt_plugin_api_a6078344 === 'function') {
    await nuxt_plugin_api_a6078344(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookiesAccess_4e96f92c === 'function') {
    await nuxt_plugin_cookiesAccess_4e96f92c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amplitude_c13dac68 === 'function') {
    await nuxt_plugin_amplitude_c13dac68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_0ac39a98 === 'function') {
    await nuxt_plugin_gtag_0ac39a98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleAnalytics_218e57a4 === 'function') {
    await nuxt_plugin_googleAnalytics_218e57a4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebook_7eccbd58 === 'function') {
    await nuxt_plugin_facebook_7eccbd58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_2a882914 === 'function') {
    await nuxt_plugin_hotjar_2a882914(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_1e2158c6 === 'function') {
    await nuxt_plugin_analytics_1e2158c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modal_0afd60a8 === 'function') {
    await nuxt_plugin_modal_0afd60a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modal_442ddd06 === 'function') {
    await nuxt_plugin_modal_442ddd06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toaster_ad413bd6 === 'function') {
    await nuxt_plugin_toaster_ad413bd6(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_54e2c789 === 'function') {
    await nuxt_plugin_meta_54e2c789(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
